import formsConfiguration from "./formsConfiguration";
import selectFieldsConfiguration from "./selectFieldsConfiguration";

function filterSelectOptions(formType, selectField) {
    const config = formsConfiguration.form[formType];
    const options = selectFieldsConfiguration[selectField];
    const filteredOptions = filterOptions(config, selectField, options);
    return filteredOptions ? filteredOptions : options;
}

function filterSelectNestedOptions(formType, selectField) {
    const options = selectFieldsConfiguration[selectField];
    let filteredOptions = options;

    const includedOptions = formsConfiguration.form[formType] &&
            formsConfiguration.form[formType].includeOptions &&
            formsConfiguration.form[formType].includeOptions[selectField];
    if (includedOptions) {
        filteredOptions = keepKeysIncluded(options, includedOptions)
                .reduce(keepValuesIncluded(options, includedOptions), {});
    }

    const excludedOptions = formsConfiguration.form[formType] &&
            formsConfiguration.form[formType].excludeOptions &&
            formsConfiguration.form[formType].excludeOptions[selectField];
    if (excludedOptions) {
        filteredOptions = removeKeysExcluded(filteredOptions, excludedOptions)
                .reduce(removeValuesExcluded(filteredOptions, excludedOptions), {});
    }

    return filteredOptions;
}

function keepKeysIncluded(options, includedOptions) {
    return Object.keys(options).filter(option => isOptionAllowed(option, Object.keys(includedOptions)));
}

function removeKeysExcluded(options, excludedOptions) {
    return Object.keys(options).filter(option => !isOptionAllowed(option, Object.keys(excludedOptions)));
}

function keepValuesIncluded(options, includedOptions) {
    return (map, key) => {
        const filtered = options[key].filter(option => isOptionAllowed(option.id, flatArray(includedOptions)));
        return (map[key] = filtered, map);
    };
}

function removeValuesExcluded(options, excludedOptions) {
    return (map, key) => {
        const filtered = options[key].filter(option => !isOptionAllowed(option.id, flatArray(excludedOptions)));
        return (map[key] = filtered, map);
    };
}

function flatArray(array) {
    return [].concat.apply([], Object.values(array));
}

function isOptionAllowed(option, optionsAllowed) {
    return optionsAllowed.includes(option);
}

function filterOptions(formConfig, selectField, options) {
    const includedOptions = formConfig.includeOptions && formConfig.includeOptions[selectField];
    let filteredOptions = options;
    if (includedOptions) {
        filteredOptions = options.filter(option => isOptionAllowed(option.id, includedOptions));
    }
    const excludedOptions = formConfig.excludeOptions && formConfig.excludeOptions[selectField];
    if (excludedOptions) {
        filteredOptions = filteredOptions.filter(option => !isOptionAllowed(option.id, excludedOptions));
    }
    return filteredOptions;
}

export default {
    filterSelectOptions: (formType, selectField) => {
        return filterSelectOptions(formType, selectField);
    },
    filterSelectNestedOptions: (formType, selectField) => {
        return filterSelectNestedOptions(formType, selectField);
    }
};


// WEBPACK FOOTER //
// ./src/components/Form/filterSelectFields.js